import { useState, ReactNode } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import InquiryForm, { InquiryValues } from "./InquiryForm";

interface QuickInquiryDialogProps {
  trigger: ReactNode;
  title?: string;
  description?: string;
  defaultInterest?: InquiryValues["interest"];
}

const QuickInquiryDialog = ({
  trigger,
  title = "Request a Private Showing",
  description = "Share a few details and John will reach out within one business day.",
  defaultInterest = "Request a Showing",
}: QuickInquiryDialogProps) => {
  const [open, setOpen] = useState(false);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <p className="eyebrow mb-2">Quick Inquiry</p>
          <DialogTitle className="font-serif text-2xl md:text-3xl font-light leading-tight">
            {title}
          </DialogTitle>
          <DialogDescription className="text-muted-foreground font-light">
            {description}
          </DialogDescription>
        </DialogHeader>
        <div className="mt-4">
          <InquiryForm
            compact
            defaultInterest={defaultInterest}
            onSubmitted={() => setOpen(false)}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default QuickInquiryDialog;
